module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pre-title":"Stories & impact"},"fr":{"pre-title":"Récits et Impact"},"es":{"pre-title":"Relatos e Improntas"}}')
  delete Component.options._Ctor
}
